import { EViewTypes } from '../../../../../../const';

export const LAST_KANBAN_VIEW_LOCALSTORAGE = 'LAST_KANBAN_VIEW_LOCALSTORAGE';

export const getLastKanbanView = (): EViewTypes => {
    return localStorage.getItem(LAST_KANBAN_VIEW_LOCALSTORAGE) as EViewTypes || EViewTypes.KANBAN_VIEW_TYPE;
};

export const setLastKanbanView = (
    viewType: EViewTypes,
) => {
    localStorage.setItem(LAST_KANBAN_VIEW_LOCALSTORAGE, viewType);
};
